/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "./Alert";
import L from "./Lang"
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fa from '@fortawesome/free-solid-svg-icons'
import FormInput from "./FormInput";
import Globals from "../shared/Globals";
import { SidebarGlobal } from "./_SidebarGlobal";

class CallList extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: []
        };
    }

    componentDidMount() {
        this.load();
    }


    componentWillUnmount() {

    }

    load = async (sort) => {
        this.setState({ loading: true });

        const query = { ... this.state.query };

        query.sort = sort;

        try {
            const j = await qreq.postAsync('/api/call/list', query);
            if (j.errorCode === 0) {
                this.setState({ list: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }

        this.setState({ loading: false, loaded: true });
    }

    search = (e) => {
        if (e)
            e.preventDefault();

        if (this.state.loading) {
            setTimeout(() => this.search(), 100);
            return;
        }

        if (this.searchTimeout)
            clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.load();
        }, 1000);
    }

    sort = (col) => {
        let sort = col.name;
        const desc = this.state.desc;
        sort += (desc ? ' DESC' : ' ASC');
        this.setState({ sort: col, desc: !desc });
        this.load(sort);
    }


    render() {
        const header = (<h1><L>Calls</L></h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />


        return <div className="container-fluid">
            {header}
            <form onSubmit={this.search}>
                <div className="mb-3">
                    <FormInput model={this.state.query} name="search" label="Search for a call..." labelAsPlaceholder onChange={() => { this.search(); }} />
                </div>
            </form>
            <div className="mt-2 pb-3">
                <DataTable columns={[
                    { name: 'fromNumber', title: 'From', valueFunc: row => Globals.formatPhone(row.fromNumber) },
                    { name: 'toNumber', title: 'To', valueFunc: row => Globals.formatPhone(row.toNumber) },
                    { name: 'contactName', title: 'Contact' },
                    { name: 'targetName', title: 'Handler' },
                    { name: 'transcription', title: 'Transcription', style: { maxWidth: '300px' }, valueFunc: row => <pre>{row.transcription}</pre> },
                    { name: 'startDate', title: 'Start Date', valueFunc: row => Globals.toMDYHMLocalDateString(row.startDate) },
                    { name: 'endDate', title: 'End Date', valueFunc: row => Globals.toMDYHMLocalDateString(row.endDate) },
                    { name: 'secondsDelta', title: 'Duration', valueFunc: row => row.secondsDelta + 's' }
                ]} data={this.state.list} loading={this.state.loading} onSort={this.sort} />
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(CallList);